import { render, staticRenderFns } from "./VocaloidContest.vue?vue&type=template&id=870e1ed2&scoped=true&"
import script from "./VocaloidContest.vue?vue&type=script&lang=js&"
export * from "./VocaloidContest.vue?vue&type=script&lang=js&"
import style0 from "./VocaloidContest.vue?vue&type=style&index=0&id=870e1ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870e1ed2",
  null
  
)

export default component.exports